<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_Sinch_URL')" prop="url">
      <el-input
        v-model="model.params.url"
        :placeholder="$t('ChannelConfig_Sinch_URL_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item :label="$t('ChannelConfig_Sinch_Token')" prop="token">
      <el-input
        v-model="model.params.token"
        :placeholder="$t('ChannelConfig_Sinch_Token_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_Sinch_ServicePlanID')"
      prop="service_plan_id"
    >
      <el-input
        v-model="model.params.service_plan_id"
        :placeholder="$t('ChannelConfig_Sinch_ServicePlanID_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },

  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'sinch')
      this.$set(this.model, 'params', {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/Sinch.vue